import React from "react";
import get from "lodash/get";
import { useFormikContext } from "formik";
import { STATE_KEYS } from "utils/constants/state";
import { SERVICE_LABEL_MAP, WORKFLOW_SERVICE } from "utils/constants/workflow";
import Docusign from "./Docusign";

const SERVICE_STEP_EDITOR_MAP = {
  [WORKFLOW_SERVICE.DOCUSIGN]: Docusign
};

const StepEditorSwitch = (props) => {
  const uuid = props.uuid;
  const { values } = useFormikContext();
  const steps = get(values, STATE_KEYS.WORKFLOW.STEPS) || [];
  const step = steps.find((step) => step.uuid === uuid);

  const StepEditor = SERVICE_STEP_EDITOR_MAP[step.service];
  if (!StepEditor) {
    return (
      <InfoNotice copy={`${SERVICE_LABEL_MAP[step.service]} not supported`} />
    );
  }
  return <StepEditor {...props} />;
};

export default StepEditorSwitch;
